import React from 'react'

const Email = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__email ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 19V6.259l9.327 8.481a1 1 0 0 0 1.346 0L22 6.261V19H2zM20.414 5l-7.741 7.037a1 1 0 0 1-1.346 0L3.588 5h16.826zM23 3H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z' />
  </svg>
)

export default Email
